export default __webpack_public_path__ + "static/media/soccer-stadium.be42b4fa.png";